import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import PropTypes from "prop-types";

const TagsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin: 0.5rem 0;
`;

const TagPill = styled(Link)`
  background-color: ${({ theme }) => theme.hoverBtn};
  color: ${({ theme }) => theme.text};
  border-radius: 12px;
  padding: 0.15rem 0.6rem;
  font-size: 0.8rem;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.text};
    text-decoration: underline;
  }
`;

const ToggleText = styled.span`
  font-size: 0.8rem;
  opacity: 0.7;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const VISIBLE_LIMIT = 5;

const EntryTags = ({ tags }) => {
  const [expanded, setExpanded] = useState(false);

  if (!tags || tags.length === 0) return null;

  const visibleTags = expanded ? tags : tags.slice(0, VISIBLE_LIMIT);
  const hiddenCount = tags.length - visibleTags.length;

  return (
    <TagsWrap>
      {visibleTags.map(tag => (
        <TagPill key={tag} to={`/tags/${tag}`}>
          #{tag}
        </TagPill>
      ))}
      {hiddenCount > 0 && (
        <ToggleText onClick={() => setExpanded(true)}>
          +{hiddenCount} more
        </ToggleText>
      )}
      {expanded && tags.length > VISIBLE_LIMIT && (
        <ToggleText onClick={() => setExpanded(false)}>Show less</ToggleText>
      )}
    </TagsWrap>
  );
};

EntryTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
};

export default EntryTags;
